import type { ReactElement } from 'react';
import { useServices, useSession, useT } from '../../../app/di';
import { Card } from '../../../ui-kit/Card/Card';
import { PageHeader } from '../../../ui-kit/PageHeader/PageHeader';
import { MyPlanSection } from '../plans';
import { PersonalSettingsSection, PreferencesControls } from '../../platform/user-preferences';
import { AccountSummary } from './AccountSummary/AccountSummary';
import { ApiKeysSection } from './ApiKeysSection';
import { canIssueOwnApiKeys } from './model/api-keys';
import { PasswordForm } from './PasswordForm/PasswordForm';

// IAM-UC-4, PREF-UC-1, PREF-UC-2, PREF-UC-3; IAM-UC-9, IAM-UC-10 — ключи API автора; PLAN-UC-5 — свой тариф
export function ProfilePage(): ReactElement | null {
  const { api } = useServices();
  const { t } = useT();
  const { me } = useSession();
  if (!me) return null;
  return (
    <div className="u-stack-lg">
      <PageHeader title={t('identity.profile.title')} />
      <AccountSummary user={me.user} />
      <Card title={t('preferences.title')}>
        <PreferencesControls />
      </Card>
      <MyPlanSection />
      <PersonalSettingsSection />
      {canIssueOwnApiKeys(me.blogs) ? <ApiKeysSection /> : null}
      <Card title={t('identity.profile.passwordTitle')}>
        <PasswordForm onSubmit={(change) => api.identity.changePassword(change.currentPassword, change.newPassword)} />
      </Card>
    </div>
  );
}
